import React from 'react';
import {
  // COCMyTeamIcon,
  COCSpecificTeamIcon,
  COCPublicIcon,
} from '@/assets/icons/icons';
import WhoCanSeeTooltip from './WhoCanSeeTooltip'; // adjust path

// Example Team type, replace with your actual type
interface Team {
  name: string;
  color: string;
}

interface CommentAudienceIconsProps {
  audienceType: string;
  teams?: Team[];
}

const CommentAudienceIcons: React.FC<CommentAudienceIconsProps> = ({
  audienceType,
  teams = [],
}) => {
  switch (audienceType) {
    case 'my_team':
    case 'specific_teams':
      return (
        <WhoCanSeeTooltip teams={teams}>
          <COCSpecificTeamIcon size={16} color='var(--gray-600)' />
        </WhoCanSeeTooltip>
      );

    case 'public':
      return <COCPublicIcon size={16} color='var(--gray-600)' />;

    default:
      return null;
  }
};

export default CommentAudienceIcons;
